import {
    COMCASTLIVEAGENTSURVEY_LOAD,
    COMCASTLIVEAGENTSURVEY_UNLOAD,
    COMCASTLIVEAGENTSURVEY_SET,
} from '../../../actionDefinitions';
import { createReducer } from '../../../reducerUtils';

const initialState =
{

};

const handlers = {
    [COMCASTLIVEAGENTSURVEY_LOAD]: (state, action) =>
    {
        if (action.error)
        {
            return { error: action.payload };
        }
        return { ...action.payload, dataLoaded: true }
    },
    [COMCASTLIVEAGENTSURVEY_UNLOAD]: () => initialState,
    [COMCASTLIVEAGENTSURVEY_SET]: (state, action) => action.updatedProps,
};

export default createReducer(initialState, handlers);
